"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sanitize = void 0;
// @ts-ignore
var DOMPurify = require("dompurify");
/**
 * Sanitize HTML strings before passing into "dangerouslySetInnerHTML"
 * @param htmlString
 */
var sanitize = function (htmlString, allowTargetAttribute) {
    if (allowTargetAttribute === void 0) { allowTargetAttribute = false; }
    if (allowTargetAttribute) {
        DOMPurify.setConfig({
            ADD_ATTR: ['target'],
        });
        DOMPurify.addHook('afterSanitizeAttributes', function (node) {
            if (allowTargetAttribute && node.target) {
                // prevent https://www.owasp.org/index.php/Reverse_Tabnabbing
                node.setAttribute('rel', 'noopener noreferrer');
            }
        });
    }
    var sanitized = DOMPurify.sanitize(htmlString);
    if (allowTargetAttribute) {
        // Reset config so next call does not contain same settings
        DOMPurify.clearConfig({});
    }
    return {
        __html: sanitized,
    };
};
exports.sanitize = sanitize;
